import { Doc } from '@dadohr/shared/domainTypes/document';
import {
  IExperience,
  IExperienceTemplate,
  InstanceErrorType
} from '@dadohr/shared/domainTypes/experience';
import { ErroDataType } from '@dadohr/shared/domainTypes/instance';
import { compact } from 'lodash';
import { getItemDisplayName, resolveExpTitle } from '../../../../helpers/adminName';
import type { InstanceErroWithData } from '../../InstanceProblems';
import { findParentTaskTemplate } from '../taskTemplateLookup';

const CC_ERROR_TYPES = new Set<string>([
  ErroDataType.CANNOT_SEND_CC_MISSING_EMAIL,
  ErroDataType.CANNOT_SEND_CC_NOT_ASSIGNED,
  ErroDataType.CC_BOUNCED,
  ErroDataType.ASSIGNEE_BOUNCED
]);

// Note: previously ended by piping through `collapseSalesforceIssues` to
// collapse duplicate Salesforce failures into a ×N row for the legacy UI.
// That collapse was removed along with `collapseSalesforceIssues.ts` — no
// org currently uses Salesforce, so there's no live behavior it needs to
// preserve, and Salesforce issues now get their own `groupBy` entry in the
// new grouping layer instead.
export const collectInstanceIssues = (
  errors: InstanceErrorType[],
  tpl: Doc<IExperienceTemplate>,
  d: Doc<IExperience>
) => {
  const issues: InstanceErroWithData[] = compact(
    errors.map((err) => {
      if (CC_ERROR_TYPES.has(err.type)) {
        return null;
      }
      const taskTpl =
        'subtaskTplId' in err
          ? findParentTaskTemplate(tpl, (err as { subtaskTplId: string }).subtaskTplId)
          : undefined;
      const issue: InstanceErroWithData = {
        ...err,
        tpl,
        instance: d,
        timelineItem: taskTpl ? resolveExpTitle(getItemDisplayName(taskTpl), tpl.data.title) : ''
      } as InstanceErroWithData;
      return Object.values(ErroDataType).includes(err.type) &&
        err.ignore === false
        ? issue
        : null;
    })
  );

  return issues;
};
